module.exports = __webpack_public_path__ + "static/media/ic_hi_b5_myway.5ded997e.svg";